import ClockType from "../enums/clock-type";
import FieldLength from "../enums/field-length";
import GoalPost from "../enums/goal-post";
import PatPoints from "../enums/pat-points";
import ParticipationStyle from "../enums/participation-style";

const DefaultFootballConfig = Object.freeze({
    general: {
        periodsInRegulation: 4,
        downs: 4,
        fieldLength: FieldLength.OptionSeven.code,
        fieldWidth: 40,
        minutesByPeriod: 15,
        firstDownYards: 10,
        // TODO: this property shouldn't be here. This is part of the flag config.
        firstDownFlagStyle: -1,
        timeoutsPerHalf: 3,
        // PSTATS-1268: timeouts per team in each overtime period, none carried
        // over from regulation. NCAA and NFHS give one; 0 keeps timeouts
        // unavailable in overtime.
        otTimeouts: 1,
        redZoneLength: 20,
        zoneLength: 20,
        endZoneLength: 10,
        includeEndZoneYardage: false,
        otTimeControl: false,
        // PSTATS-1268: the length of a timed overtime period. Shown directly
        // after OT Time Control, and only while it is on.
        otMinutesByPeriod: 10,
        autoFairCatchTb: false,
        rushType: false,
        passType: false,
        spikeTeamAttOnly: false,
        touchdownsCountAsFirstDowns: true,
        teamLossOnly: [],
        collectStatsOnPat: false,
        collectStatsForOnSideKicks: false,
        teamZoneQty: 1,
        promptToSkipKickoff: [],
        participationStyle: ParticipationStyle.Default.code
    },
    clock: {
        clockType: ClockType.DESC.code,
        // When true, the game context is created with a real-time running
        // clock instead of a manual one. Toggleable mid-game via
        // ContextService.reconcileClock.
        runningClock: false
    },
    spots: {
        kickoff: 35,
        KOTouchback: 25,
        otherTouchback: 20,
        PATTry: 3,
        safetyKO: 20,
        driveStartingYardline: 14,
        touchbackYardline: 25,
        rougeYardline: 40,
        // PSTATS-1268: overtime played like regulation (kickoffs after the
        // toss and scores). Shown in Spots directly before Overtime Starting
        // Yardline, which it makes unused, so the switch never moves when it
        // hides that field; off by default, so overtime is unchanged unless a
        // crew opts in.
        otKickoffs: false,
        overtimeStartingYardline: 10,
        spotsPatScoreOption1: 3,
        spotsPatScoreOption2: 10,
        spotsPatScoreOption3: 20,
        goalPostLocation: GoalPost.END_LINE.code,
        missedFieldGoalMinSpot: 20,
        missedFieldGoalSpot: null
    },
    scoring: {
        touchdown: 6,
        kickPAT: 1,
        runPAT: 2,
        safety: 2,
        rougePoints: 1,
        fieldGoal: 3,
        defensivePAT: 2,
        scoringPatScoreOption1: PatPoints.OptionOne.value,
        scoringPatScoreOption2: PatPoints.OptionTwo.value,
        scoringPatScoreOption3: PatPoints.OptionThree.value,
        playSummary: true
    }
});

export default DefaultFootballConfig;
